import(/* webpackMode: "eager" */ "/home/hein/work/git/SimpWeb/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "/home/hein/work/git/SimpWeb/node_modules/next/dist/shared/lib/lazy-dynamic/preload-css.js");
;
import(/* webpackMode: "eager" */ "/home/hein/work/git/SimpWeb/src/components/landing/LandingPage.tsx");
